import script from "./AddContract.vue?vue&type=script&setup=true&lang=js"
export * from "./AddContract.vue?vue&type=script&setup=true&lang=js"

import "./AddContract.vue?vue&type=style&index=0&id=5ea1f18c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea1f18c"]])

export default __exports__